// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./shared/assets/fonts/Inter-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./shared/assets/fonts/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./shared/assets/fonts/Inter-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./shared/assets/fonts/Inter-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./shared/assets/fonts/RethinkSans-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./shared/assets/fonts/RethinkSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./shared/assets/fonts/RethinkSans-Italic.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./shared/assets/fonts/RethinkSans-Italic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom font declarations */
/* §3.1 — font-display: swap prevents FOIT; woff2 is listed first for modern browsers */
@font-face {
  font-family: 'Inter-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Inter-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}

@font-face {
  font-family: 'RethinkSans-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'RethinkSans-Regular';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
       url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('truetype');
  font-weight: normal;
  font-style: italic;
  font-display: swap;
}

/* Reset and base styles for React Native Web */
html, body, #root {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Ensure React Native Web root container fills viewport */
#root > div {
  height: 100%;
}

/* Accessibility: Button wrapper uses display:contents so it is layout-transparent.
   When the wrapper <button> receives keyboard focus, forward the focus ring to
   its first rendered child (the TouchableOpacity div). */
button[aria-label]:focus-visible > div:first-child {
  /* outline: 2px solid #0071C5; */
  outline-offset: 2px;
  border-radius: 4px;
}

/* ─── Themed scrollbar (web only) ────────────────────────────────────────────
   --scrollbar-thumb  : initialised from tokens.primarySoft in index.web.tsx.
   --scrollbar-size   : initialised from Typography.borderWidth.borderWidth6 in
                        index.web.tsx (= 6 px, a fixed dimension constant).
   Both are overwritten synchronously before React renders, so no flash occurs.
   useScrollbarTheme.web.ts updates --scrollbar-thumb on client-theme change.
   ──────────────────────────────────────────────────────────────────────────── */
:root {
  --scrollbar-thumb: transparent; /* overwritten immediately by index.web.tsx */
  --scrollbar-track: transparent;
  --scrollbar-size: 6px;          /* overwritten immediately by index.web.tsx */
}

/* Webkit browsers (Chrome, Edge, Safari) */
::-webkit-scrollbar {
  width: var(--scrollbar-size);
  height: var(--scrollbar-size);
}

::-webkit-scrollbar-track {
  background: var(--scrollbar-track);
}

::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  opacity: 0.8;
}

/* Firefox — uses the two-value shorthand: thumb-color track-color */
* {
  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
  scrollbar-width: thin;
}`, "",{"version":3,"sources":["webpack://./src/index.web.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B,uFAAuF;AACvF;EACE,4BAA4B;EAC5B;iEACsE;EACtE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B;iEACqE;EACrE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC;iEAC4E;EAC5E,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC;iEAC2E;EAC3E,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA,0DAA0D;AAC1D;EACE,YAAY;AACd;;AAEA;;yDAEyD;AACzD;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;iFAMiF;AACjF;EACE,8BAA8B,EAAE,6CAA6C;EAC7E,8BAA8B;EAC9B,qBAAqB,WAAW,6CAA6C;AAC/E;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA,oEAAoE;AACpE;EACE,8DAA8D;EAC9D,qBAAqB;AACvB","sourcesContent":["/* Custom font declarations */\n/* §3.1 — font-display: swap prevents FOIT; woff2 is listed first for modern browsers */\n@font-face {\n  font-family: 'Inter-Regular';\n  src: url('./shared/assets/fonts/Inter-Regular.woff2') format('woff2'),\n       url('./shared/assets/fonts/Inter-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Inter-Regular';\n  src: url('./shared/assets/fonts/Inter-Italic.woff2') format('woff2'),\n       url('./shared/assets/fonts/Inter-Italic.ttf') format('truetype');\n  font-weight: normal;\n  font-style: italic;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'RethinkSans-Regular';\n  src: url('./shared/assets/fonts/RethinkSans-Regular.woff2') format('woff2'),\n       url('./shared/assets/fonts/RethinkSans-Regular.ttf') format('truetype');\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'RethinkSans-Regular';\n  src: url('./shared/assets/fonts/RethinkSans-Italic.woff2') format('woff2'),\n       url('./shared/assets/fonts/RethinkSans-Italic.ttf') format('truetype');\n  font-weight: normal;\n  font-style: italic;\n  font-display: swap;\n}\n\n/* Reset and base styles for React Native Web */\nhtml, body, #root {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n}\n\nbody {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Ensure React Native Web root container fills viewport */\n#root > div {\n  height: 100%;\n}\n\n/* Accessibility: Button wrapper uses display:contents so it is layout-transparent.\n   When the wrapper <button> receives keyboard focus, forward the focus ring to\n   its first rendered child (the TouchableOpacity div). */\nbutton[aria-label]:focus-visible > div:first-child {\n  /* outline: 2px solid #0071C5; */\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n/* ─── Themed scrollbar (web only) ────────────────────────────────────────────\n   --scrollbar-thumb  : initialised from tokens.primarySoft in index.web.tsx.\n   --scrollbar-size   : initialised from Typography.borderWidth.borderWidth6 in\n                        index.web.tsx (= 6 px, a fixed dimension constant).\n   Both are overwritten synchronously before React renders, so no flash occurs.\n   useScrollbarTheme.web.ts updates --scrollbar-thumb on client-theme change.\n   ──────────────────────────────────────────────────────────────────────────── */\n:root {\n  --scrollbar-thumb: transparent; /* overwritten immediately by index.web.tsx */\n  --scrollbar-track: transparent;\n  --scrollbar-size: 6px;          /* overwritten immediately by index.web.tsx */\n}\n\n/* Webkit browsers (Chrome, Edge, Safari) */\n::-webkit-scrollbar {\n  width: var(--scrollbar-size);\n  height: var(--scrollbar-size);\n}\n\n::-webkit-scrollbar-track {\n  background: var(--scrollbar-track);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb);\n  border-radius: 3px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  opacity: 0.8;\n}\n\n/* Firefox — uses the two-value shorthand: thumb-color track-color */\n* {\n  scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);\n  scrollbar-width: thin;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
